import { defineMessages } from "react-intl";

const PREFIX = "EmailConfirmedPage";
export default defineMessages({
  header: {
    id: `${PREFIX}.header`,
    defaultMessage: "Email successfully confirmed",
  },
  goto: {
    id: `${PREFIX}.goto`,
    defaultMessage: "Go to authorization page",
  },
});
